export default __webpack_public_path__ + "static/media/img6.73b58950.jpg";